module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/image-grid/grid-01-fe4f7f4b443ca4ed5a9ba67f32feabe4.jpg";